import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/cc-visa': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M470.1 231.3S477.7 268.5 479.4 276.3H446C449.3 267.4 462 232.8 462 232.8 461.8 233.1 465.3 223.7 467.3 217.9L470.1 231.3zM576 80V432C576 458.5 554.5 480 528 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H528C554.5 32 576 53.5 576 80zM152.5 331.2L215.7 176H173.2L133.9 282 129.6 260.5 115.6 189.1C113.3 179.2 106.2 176.4 97.4 176H32.7L32 179.1C47.8 183.1 61.9 188.9 74.2 196.2L110 331.2H152.5zM246.9 331.4L272.1 176H231.9L206.8 331.4H246.9zM386.8 280.6C387 262.9 376.2 249.4 353.1 238.3 339 231.2 330.4 226.4 330.4 219.1 330.6 212.5 337.7 205.7 353.5 205.7 366.6 205.4 376.2 208.5 383.4 211.6L387 213.3 392.5 179.7C384.6 176.6 372 173.1 356.5 173.1 316.8 173.1 288.9 194.3 288.7 224.5 288.4 246.8 308.7 259.2 323.9 266.7 339.4 274.3 344.7 279.3 344.7 286 344.5 296.4 332.1 301.2 320.6 301.2 304.6 301.2 296 298.7 282.9 292.9L277.6 290.4 272 325.3C281.4 329.6 298.8 333.4 316.8 333.6 359 333.7 386.5 312.8 386.8 280.6zM528 331.4L495.6 176H464.5C454.9 176 447.6 178.8 443.5 188.9L383.8 331.4H426S432.9 312.2 434.4 308.1H486C487.2 313.6 490.8 331.4 490.8 331.4H528z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/cc-visa.js
// module id = 1VUa
// module chunks = 144